import React from "react"
import { Redirect, Route, RouteProps, Switch } from "react-router-dom"

import { StartPagePath } from "./paths"
import { TwoFactorAuthenticationProtectedScreenContent } from "../screens/2FA"
import { ExternalLogin } from "../screens/ExternalLogin"
import { LoginWithKeycodeProtectedScreenContent } from "../screens/LoginWithKeycode"
import { LoginWithPasswordProtectedScreenContent } from "../screens/LoginWithPassword"
import { LoginWithSamlProtectedScreenContent } from "../screens/LoginWithSaml/ProtectedScreenContent"
import { MasterLogin } from "../screens/MasterLogin"
import { ResetPasswordProtectedScreenContent } from "../screens/ResetPassword"
import { ResetPasswordConfirmProtectedScreenContent } from "../screens/ResetPasswordConfirm"
import { RoleProtectedScreenContent } from "../screens/Role"
import { SchoolyearEndProtectedScreenContent } from "../screens/SchoolyearEndScreen"

export const StartPageOutlet = () => (<Switch>
	<LoginRoute path="/login" component={LoginWithPasswordProtectedScreenContent} />
	<LoginRoute path="/keycode" component={LoginWithKeycodeProtectedScreenContent} />
	<LoginRoute path="/saml" component={LoginWithSamlProtectedScreenContent} />
	<LoginRoute path="/reset-password" component={ResetPasswordProtectedScreenContent} />
	<LoginRoute path="/reset-password-confirm/:token" component={ResetPasswordConfirmProtectedScreenContent} />
	<LoginRoute path="/role" component={RoleProtectedScreenContent} />
	<LoginRoute path="/schoolyear-end" component={SchoolyearEndProtectedScreenContent} />
	<LoginRoute path="/2fa" component={TwoFactorAuthenticationProtectedScreenContent} />
	<LoginRoute path="/master-login" component={MasterLogin} />
	<LoginRoute path="/external-login" component={ExternalLogin} />
	<LoginRoute path="*"><Redirect to="/" /></LoginRoute>
</Switch>)

const LoginRoute = (props: Omit<RouteProps, "path"> & {
	path: StartPagePath
}) => <Route {...props} />
